import { render, staticRenderFns } from "./AdminWorkplace.vue?vue&type=template&id=42f74822&"
import script from "./AdminWorkplace.vue?vue&type=script&lang=js&"
export * from "./AdminWorkplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports